const readEnv = (key: string): string | undefined => {
  if (typeof globalThis !== 'undefined') {
    const maybeProcess = (globalThis as typeof globalThis & {
      process?: { env?: Record<string, string | undefined> };
    }).process;

    const value = maybeProcess?.env?.[key];
    if (typeof value === 'string' && value.trim().length > 0) {
      return value;
    }
  }

  return undefined;
};

export const getApiBaseUrl = (): string => readEnv('REACT_APP_API_URL') ?? '';